"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUAccount = void 0;
const bu_account_api_flow_1 = require("./bu_account_api_flow");
const bu_account_token_manager_1 = require("./bu_account_token_manager");
const bu_account_types_1 = require("./bu_account_types");
const client_1 = require("./secure-remote-password/client");
class BUAccount {
    constructor(clientId, deviceId, host) {
        this.clientId = clientId;
        this.deviceId = deviceId;
        this.host = host;
        this.tokenManager = new bu_account_token_manager_1.BUAccountTokenManager(host);
        const clientInfos = clientId.split("_");
        if (clientInfos[1] === "web") {
            this.tokenManager.shouldRefreshRefreshToken = false;
        }
    }
    /**
     * @deprecated 拼写错误
     */
    get tokenStorate() {
        return this.tokenManager.tokenStorage;
    }
    /**
     * @deprecated 拼写错误
     */
    set tokenStorate(storage) {
        this.tokenManager.tokenStorage = storage;
    }
    get tokenStorage() {
        return this.tokenManager.tokenStorage;
    }
    set tokenStorage(storage) {
        this.tokenManager.tokenStorage = storage;
    }
    updateToken(token) {
        if (token.use === bu_account_types_1.BUAccountTokenUsage.refresh) {
            this.tokenManager.setRefreshToken(token);
        }
        else if (token.use === bu_account_types_1.BUAccountTokenUsage.access) {
            this.tokenManager.setAccessToken(token);
        }
    }
    register(param, sessionHandler) {
        param.client_id = this.clientId;
        param.device_id = this.deviceId;
        const { host: registerHost } = param, _param = __rest(param, ["host"]);
        return (0, bu_account_api_flow_1.apiRequest)(registerHost || this.host, "account/register_v2", _param, {}, sessionHandler).then((result) => {
            if (result.access_token) {
                this.tokenManager.setAccessToken({
                    use: bu_account_types_1.BUAccountTokenUsage.access,
                    token: result.access_token.token || "",
                    expireAt: result.access_token.expire_at || 0,
                });
            }
            if (result.refresh_token) {
                this.tokenManager.setRefreshToken({
                    use: bu_account_types_1.BUAccountTokenUsage.refresh,
                    token: result.refresh_token.token || "",
                    expireAt: result.refresh_token.expire_at || 0,
                });
            }
            return result;
        });
    }
    thirdRegister(param, sessionHandler) {
        param.client_id = this.clientId;
        param.device_id = this.deviceId;
        const { host: registerHost } = param, _param = __rest(param, ["host"]);
        return (0, bu_account_api_flow_1.apiRequest)(registerHost || this.host, "third_account/register", _param, {}, sessionHandler).then((result) => {
            if (result.access_token) {
                this.tokenManager.setAccessToken({
                    use: bu_account_types_1.BUAccountTokenUsage.access,
                    token: result.access_token.token || "",
                    expireAt: result.access_token.expire_at || 0,
                });
            }
            if (result.refresh_token) {
                this.tokenManager.setRefreshToken({
                    use: bu_account_types_1.BUAccountTokenUsage.refresh,
                    token: result.refresh_token.token || "",
                    expireAt: result.refresh_token.expire_at || 0,
                });
            }
            return result;
        });
    }
    thirdBind(param, sessionHandler) {
        const clientEphemeral = (0, client_1.generateEphemeral)();
        param.srp_A = clientEphemeral.public;
        param.client_id = this.clientId;
        param.device_id = this.deviceId;
        const { host: loginHost } = param, _param = __rest(param, ["host"]);
        return (0, bu_account_api_flow_1.apiRequest)(loginHost || this.host || this.host, "third_account/bind", _param, { clientEphemeral }, sessionHandler).then((result) => {
            if (result.access_token) {
                this.tokenManager.setAccessToken({
                    use: bu_account_types_1.BUAccountTokenUsage.access,
                    token: result.access_token.token || "",
                    expireAt: result.access_token.expire_at || 0,
                });
            }
            if (result.refresh_token) {
                this.tokenManager.setRefreshToken({
                    use: bu_account_types_1.BUAccountTokenUsage.refresh,
                    token: result.refresh_token.token || "",
                    expireAt: result.refresh_token.expire_at || 0,
                });
            }
            return result;
        });
    }
    login(param, sessionHandler) {
        const clientEphemeral = (0, client_1.generateEphemeral)();
        param.srp_A = param.enable_passkey ? "" : clientEphemeral.public;
        param.client_id = this.clientId;
        param.device_id = this.deviceId;
        const { host: loginHost } = param, _param = __rest(param, ["host"]);
        return (0, bu_account_api_flow_1.apiRequest)(loginHost || this.host, "account/login_v3", _param, { clientEphemeral }, sessionHandler).then((result) => {
            if (result.access_token) {
                this.tokenManager.setAccessToken({
                    use: bu_account_types_1.BUAccountTokenUsage.access,
                    token: result.access_token.token || "",
                    expireAt: result.access_token.expire_at || 0,
                });
            }
            if (result.refresh_token) {
                this.tokenManager.setRefreshToken({
                    use: bu_account_types_1.BUAccountTokenUsage.refresh,
                    token: result.refresh_token.token || "",
                    expireAt: result.refresh_token.expire_at || 0,
                });
            }
            return result;
        });
    }
    thirdAuth(param, sessionHandler) {
        const clientEphemeral = (0, client_1.generateEphemeral)();
        param.srp_A = clientEphemeral.public;
        param.client_id = this.clientId;
        param.device_id = this.deviceId;
        const { host: loginHost } = param, _param = __rest(param, ["host"]);
        return (0, bu_account_api_flow_1.apiRequest)(loginHost || this.host, "third_account/auth", _param, { clientEphemeral }, sessionHandler).then((result) => {
            if (result.access_token) {
                this.tokenManager.setAccessToken({
                    use: bu_account_types_1.BUAccountTokenUsage.access,
                    token: result.access_token.token || "",
                    expireAt: result.access_token.expire_at || 0,
                });
            }
            if (result.refresh_token) {
                this.tokenManager.setRefreshToken({
                    use: bu_account_types_1.BUAccountTokenUsage.refresh,
                    token: result.refresh_token.token || "",
                    expireAt: result.refresh_token.expire_at || 0,
                });
            }
            return result;
        });
    }
    getAccessToken(force = false) {
        return this.tokenManager.getAccessToken(force);
    }
    logout() {
        return this.tokenManager
            .getAccessToken()
            .then((token) => (0, bu_account_api_flow_1.apiRequest)(this.host, "account/logout", {}, {}, null, token.token))
            .then((result) => {
            this.tokenManager.setAccessToken(null);
            this.tokenManager.setRefreshToken(null);
            return result;
        })
            .catch((error) => {
            this.tokenManager.setAccessToken(null);
            this.tokenManager.setRefreshToken(null);
            return {};
        });
    }
    verifyAccount(param, sessionHandler) {
        param.client_id = this.clientId;
        param.device_id = this.deviceId;
        return this.tokenManager
            .getAccessToken()
            .then((token) => (0, bu_account_api_flow_1.apiRequest)(this.host, "account/send_kyc_verify_code", Object.assign({}, param), {}, sessionHandler, token.token));
    }
    logout_all() {
        return this.tokenManager
            .getAccessToken()
            .then((token) => (0, bu_account_api_flow_1.apiRequest)(this.host, "account/logout_all", {}, {}, null, token.token))
            .then((result) => {
            this.tokenManager.setAccessToken(null);
            this.tokenManager.setRefreshToken(null);
            return result;
        })
            .catch((error) => {
            this.tokenManager.setAccessToken(null);
            this.tokenManager.setRefreshToken(null);
            return {};
        });
    }
    forgetPassword(param, sessionHandler) {
        param.client_id = this.clientId;
        param.device_id = this.deviceId;
        return (0, bu_account_api_flow_1.apiRequest)(this.host, "account/forget_password_v2", param, {}, sessionHandler);
    }
    changePassword(sessionHandler) {
        return this.getAccessToken().then((token) => {
            const clientEphemeral = (0, client_1.generateEphemeral)();
            const param = {};
            param.srp_A = clientEphemeral.public;
            param.client_id = this.clientId;
            param.device_id = this.deviceId;
            param.access_token = token.token;
            return (0, bu_account_api_flow_1.apiRequest)(this.host, "account/change_password", param, { clientEphemeral }, sessionHandler);
        });
    }
    getUserInfo() {
        return this.getAccessToken()
            .then((token) => (0, bu_account_api_flow_1.apiRequest)(this.host, "account/user_info", {}, {}, null, token.token))
            .then((data) => data);
    }
    unbindOTP(otp_code) {
        return this.getAccessToken().then((token) => (0, bu_account_api_flow_1.apiRequest)(this.host, "otp/unbind", {
            otp_code: otp_code,
        }, {}, null, token.token));
    }
    queryOTP() {
        return this.getAccessToken().then((token) => (0, bu_account_api_flow_1.apiRequest)(this.host, "otp/query", {}, {}, null, token.token));
    }
    accountBind(param, sessionHandler) {
        return this.getAccessToken().then((token) => (0, bu_account_api_flow_1.apiRequest)(this.host, "account/account_bind", Object.assign({}, param), {}, sessionHandler, token.token));
    }
    unbindAccount(param, sessionHandler) {
        return this.getAccessToken().then((token) => (0, bu_account_api_flow_1.apiRequest)(this.host, "account/account_unbind", Object.assign({}, param), {}, sessionHandler, token.token));
    }
    closeAccount(param) {
        param.client_id = this.clientId;
        param.device_id = this.deviceId;
        return this.getAccessToken().then((token) => (0, bu_account_api_flow_1.apiRequest)(this.host, "account/close_user", Object.assign({}, param), {}, null, token.token));
    }
    safeCloseAccount(param, sessionHandler) {
        return this.getAccessToken().then((token) => (0, bu_account_api_flow_1.apiRequest)(this.host, "account/close_user", Object.assign({}, param), {}, sessionHandler, token.token));
    }
    bindOTPV2(param, sessionHandler) {
        return this.getAccessToken().then((token) => (0, bu_account_api_flow_1.apiRequest)(this.host, "otp/bind_v2", Object.assign({}, param), {}, sessionHandler, token.token));
    }
    resetOtpV2(param, sessionHandler) {
        const clientEphemeral = (0, client_1.generateEphemeral)();
        param.srp_A = clientEphemeral.public;
        param.client_id = this.clientId;
        param.device_id = this.deviceId;
        return (0, bu_account_api_flow_1.apiRequest)(this.host, "account/request_reset_otp_v2", param, { clientEphemeral }, sessionHandler).then((result) => {
            if (result.access_token) {
                this.tokenManager.setAccessToken({
                    use: bu_account_types_1.BUAccountTokenUsage.access,
                    token: result.access_token.token || "",
                    expireAt: result.access_token.expire_at || 0,
                });
            }
            if (result.refresh_token) {
                this.tokenManager.setRefreshToken({
                    use: bu_account_types_1.BUAccountTokenUsage.refresh,
                    token: result.refresh_token.token || "",
                    expireAt: result.refresh_token.expire_at || 0,
                });
            }
            return result;
        });
    }
    resetSecurityAccount(param, sessionHandler) {
        const clientEphemeral = (0, client_1.generateEphemeral)();
        param.srp_A = clientEphemeral.public;
        param.client_id = this.clientId;
        param.device_id = this.deviceId;
        return (0, bu_account_api_flow_1.apiRequest)(this.host, "account/reset_security_account", param, { clientEphemeral }, sessionHandler);
    }
    bindBiometricsAuth(param, sessionHandler) {
        return this.getAccessToken().then((token) => (0, bu_account_api_flow_1.apiRequest)(this.host, "otp/bind_biometric_keys", Object.assign({}, param), {}, sessionHandler, token.token));
    }
    hasBoundBiometrics(biometricKeyMd5) {
        return this.getAccessToken()
            .then((token) => (0, bu_account_api_flow_1.apiRequest)(this.host, "otp/has_biometric_keys", { biometric_key_md5: biometricKeyMd5 }, {}, null, token.token))
            .then((data) => {
            return data;
        });
    }
    getSignedDevices() {
        return this.getAccessToken().then((token) => (0, bu_account_api_flow_1.apiRequest)(this.host, "account/get_refresh_token_list", {}, {}, null, token.token));
    }
    revokeSignedDevice(param) {
        return this.getAccessToken().then((token) => (0, bu_account_api_flow_1.apiRequest)(this.host, "account/revoke_refresh_token", Object.assign({}, param), {}, null, token.token));
    }
    bindPasskey(param, sessionHandler) {
        return this.getAccessToken().then((token) => (0, bu_account_api_flow_1.apiRequest)(this.host, "otp/bind_passkey", Object.assign({}, param), {}, sessionHandler, token.token));
    }
    removePasskey(param, sessionHandler) {
        return this.getAccessToken().then((token) => (0, bu_account_api_flow_1.apiRequest)(this.host, "otp/unbind_passkey", Object.assign({}, param), {}, sessionHandler, token.token));
    }
}
exports.BUAccount = BUAccount;
